import * as React from "react";
const SvgFiBrandsFlickr = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-flickr_svg__a)">
      <path
        fill="#151A2D"
        d="M22.322 0H2.678C1.2 0 0 1.152 0 2.571v18.857C0 22.848 1.2 24 2.678 24h19.643C23.8 24 25 22.848 25 21.429V2.571C25 1.152 23.8 0 22.322 0M8.064 15.375c-1.959 0-3.544-1.521-3.544-3.402s1.584-3.402 3.544-3.402 3.543 1.521 3.543 3.402-1.585 3.402-3.543 3.402m8.872 0c-1.958 0-3.543-1.521-3.543-3.402s1.584-3.402 3.543-3.402 3.544 1.521 3.544 3.402-1.585 3.402-3.544 3.402"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-flickr_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsFlickr;
